"use client";
import { useEffect, useId } from "react";

export function useFreezeScroll(isFrozen: boolean) {
  const instanceId = useId();

  useEffect(() => {
    frozenInstances.set(instanceId, isFrozen);
    updateFreezeScrollClass();

    return () => {
      frozenInstances.delete(instanceId);
      updateFreezeScrollClass();
    };
  }, [isFrozen, instanceId]);
}

const frozenInstances = new Map<string, boolean>();

function updateFreezeScrollClass() {
  const shouldFreeze = Array.from(frozenInstances.values()).some((frozen) => frozen);

  if (shouldFreeze) {
    document.documentElement.classList.add("freeze-scroll");
    document.body.classList.add("freeze-scroll");
  } else {
    document.documentElement.classList.remove("freeze-scroll");
    document.body.classList.remove("freeze-scroll");
  }
}

